import * as brandTheme from "./brandTheme";
import * as legacyTheme from "./legacyTheme";
import { isBrandLook } from "./look";

// Both modules export the same API; the active look decides which one the
// app sees. See ./look.ts.
const active = isBrandLook ? brandTheme : legacyTheme;

export type { AnyColour, Colour } from "./brandTheme";

export const {
  colors,
  colours,
  isModifiableColour,
  parseModifiableColour,
  getChartColours,
  intentsifyTheme,
  useComponentColors,
} = active;
